import dayjs from "dayjs";
import { z } from "zod";
import { IObject } from "@entities/api/object";
import { FormType } from "../../types/form-type";
import { DocumentationPermissionSchema } from "../object-form-edit.schema";

type DocumentationPermission = z.infer<typeof DocumentationPermissionSchema>;

export function objectToFormMapper(object: IObject): FormType {
  const permissionsRequired = Boolean(object.documentationPermissions?.length);
  const examinationsRequired = Boolean(
    object.documentationExaminations?.length,
  );

  // @ts-expect-error it just works
  const documentationPermissions: DocumentationPermission[] =
    object.documentationPermissions.map((p) => {
      const file = p.permissionFile.file.fileId
        ? { id: p.permissionFile.file.fileId }
        : null;
      return {
        documentationPermissionId: p.documentationPermissionId,
        prolongDate: p.prolongDate ? dayjs(p.prolongDate) : null,
        expiryDate: p.expiryDate ? dayjs(p.expiryDate) : null,
        issued: p.issued,
        number: p.number,
        date: p.date ? dayjs(p.date) : null,
        file,
      };
    });

  // @ts-expect-error it just works
  const documentationExaminations: DocumentationPermission[] =
    object.documentationExaminations.map((p) => {
      const file = p.examinationFile?.file?.fileId
        ? { id: p.examinationFile.file.fileId }
        : null;
      return {
        documentationExaminationId: p.documentationExaminationId,
        issued: p.issued,
        number: p.number,
        date: p.date ? dayjs(p.date) : null,
        file,
      };
    });

  return {
    fullName: object.fullName,
    shortName: object.shortName,
    descriptionProjects: object.descriptionProjects,
    descriptionStage: object.descriptionStage,
    constructionType: object.constructionType,
    // @ts-expect-error dayjs | date
    buildingStart: object.buildingStart ? dayjs(object.buildingStart) : null,
    // @ts-expect-error dayjs | date
    buildingEnd: object.buildingEnd ? dayjs(object.buildingEnd) : null,

    permissions: {
      required: permissionsRequired,
      documentationPermissions,
    },

    examinations: {
      required: examinationsRequired,
      documentationExaminations,
    },
  };
}
